import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { MerchantsCreate } from './MerchantsCreate/MerchantsCreate';
import { MerchantsEdit } from './MerchantsEdit/MerchantsEdit';
import { MerchantsList } from './MerchantsList/MerchantsList';
import { MerchantsShow } from './MerchantsShow/MerchantsShow';

export const merchantsResource: ResourceProps = {
  name: Resources.Merchants,
  create: MerchantsCreate,
  edit: MerchantsEdit,
  list: MerchantsList,
  show: MerchantsShow,
};
